import light from './light.coffee';

import dark from './dark.coffee';

import dim from './dim.coffee';

import brown from './brown.coffee';

export default [brown, dark, light, dim];
